import { ListenerType } from '../schema/ListenerType';
import { AppContext } from '../schema/AppContext';

/**
 * Use this utility to register the app signal listeners
 */
export function registerListener(listener: ListenerType) {
    const listeners = AppContext.listeners;
    if (listeners.indexOf(listener) === -1) {
        listeners.push(listener);
    }
}
